import { render, staticRenderFns } from "./myproduct.vue?vue&type=template&id=3fff3b92&scoped=true"
import script from "./myproduct.vue?vue&type=script&lang=js"
export * from "./myproduct.vue?vue&type=script&lang=js"
import style0 from "./myproduct.vue?vue&type=style&index=0&id=3fff3b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff3b92",
  null
  
)

export default component.exports